import {dndPromotion, getAwardSrcById} from "../../setup/js/_promotion";

$(document).on("vltk_cachep_exchange rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);
    
});